module.exports = __webpack_public_path__ + "img/Publish-Thumbnail.392111be.jpeg";